module.exports = __webpack_public_path__ + "2798c9887db59989d2fe18e9507d8636.woff2";